module.exports = __webpack_public_path__ + "img/text.4c1157f5.svg";